/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import i from "prop-types";
import { validatePackage as T, useCustomComponent as f, useAsyncFocusBlur as P, classNames as S, kendoThemeMaps as m } from "@progress/kendo-react-common";
import { packageMetadata as O } from "../package-metadata.mjs";
const v = e.forwardRef((n, g) => {
  T(O);
  const u = e.useRef(null), a = e.useRef(null), r = e.useRef(), k = e.useCallback(
    () => {
      var t;
      return r.current !== void 0 ? r.current : (t = u.current) == null ? void 0 : t.value;
    },
    []
  );
  e.useImperativeHandle(
    a,
    () => ({
      get element() {
        return u.current;
      },
      get name() {
        return u.current && u.current.name;
      },
      get value() {
        return k();
      }
    })
  ), e.useImperativeHandle(
    g,
    () => a.current
  );
  const {
    size: o = l.size,
    fillMode: d = l.fillMode,
    rounded: s = l.rounded,
    className: x,
    dir: h,
    style: p,
    prefix: C = l.prefix,
    suffix: y = l.suffix,
    valid: $,
    // Destruct to avoid warning when used inside a form field
    modified: q,
    touched: H,
    visited: I,
    ...B
  } = n, [M] = f(C), [E] = f(y), [F, c] = e.useState(!1), R = (t) => {
    c(!0);
  }, _ = (t) => {
    c(!1);
  }, b = e.useCallback(
    (t) => {
      r.current = t.target.value, n.onChange && n.onChange.call(void 0, {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent,
        value: t.target.value,
        target: a.current
      }), r.current = void 0;
    },
    [n.onChange]
  ), { onFocus: z, onBlur: N } = P({
    onFocus: R,
    onBlur: _,
    onSyncFocus: n.onFocus,
    onSyncBlur: n.onBlur
  });
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      style: p,
      dir: h,
      className: S(
        "k-textbox k-input",
        {
          [`k-input-${m.sizeMap[o] || o}`]: o,
          [`k-input-${d}`]: d,
          [`k-rounded-${m.roundedMap[s] || s}`]: s
        },
        {
          "k-focus": F,
          "k-required": n.required,
          "k-disabled": n.disabled,
          "k-invalid": n.valid === !1
        },
        x
      ),
      onFocus: z,
      onBlur: N
    },
    /* @__PURE__ */ e.createElement(M, null),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: u,
        className: "k-input-inner",
        ...B,
        onChange: b
      }
    ),
    /* @__PURE__ */ e.createElement(E, null)
  );
}), l = {
  prefix: (n) => null,
  suffix: (n) => null,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
v.propTypes = {
  size: i.oneOf([null, "small", "medium", "large"]),
  rounded: i.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: i.oneOf([null, "solid", "flat", "outline"])
};
v.displayName = "KendoReactTextBoxComponent";
export {
  v as TextBox
};
